import { call, put, takeEvery } from "redux-saga/effects";
import {
  MANUAL_URL, MANUAL_BY_SITEID,MANUAL_BY_CLIENT, ALL_CATEGORY_DATA_SUCCESS, ADD_MANUAL, UPDATE_NEW_MANUAL, DELETE_MANUAL_BYID, ADD_DRAWING, UPDATE_NEW_DRAWING, DELETE_DRAWING_BYID, ALL_CHANGETYPE_DATA,CATEGORY_DRAWING_DATA,
} from "./actionTypes";
import {

  togglePageLoader,
  ManualListError,
  manualListSuccess,
  allCategoryListSuccess,
  allChangetypeListSuccess,
  ChangetypeListError,
  categoryListError,
  onAddnewManualSuccess,
  onAddnewManualError,onupdateManualSuccess,
  onupdateManualError,
  onDeletemanualSuccess,
  onDeletemanualError,
  onAddnewDrawingSuccess,
  OnAddnewDrawingError,
  onupdateDrawingSuccess,
  onupdateDrawingError,
  onDeletedrawingSuccess,
  onDeletedrawingError,
  manualclinetListSuccess,
  CategorydrawinglistbysiteError,
  CategorydrawinglistbysiteSucess
} from "../actions";

import { getallManuals, getallCategory,getallChangetype, getManualbySiteId,getManualbyClientId, postAddManual, patchUpdateManual,deleteManualById,postAddDrawing,patchUpdateDrawing,deleteDrawingById,getDrawingbySiteId} from "../../helpers/api";

import toast from "toastr";
import { notifications } from "@mantine/notifications";

function* getManualsUrlList({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getallManuals, params, exportname);
    if (exports !== "export") {
       if (response) {
      yield put(manualListSuccess(response));
      yield put(togglePageLoader(false));
       } else {
      yield put(ManualListError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
    }
    } 
    else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}


function* fetchManualsBySiteId({ payload: params }) {
  try {
    yield put(togglePageLoader(true));
    const siteId = params.siteId || params;
    const response = yield call(getManualbySiteId, {siteId});
    if (response) {
    yield put(manualListSuccess(response));
    yield put(togglePageLoader(false));
    } else {
    yield put(ManualListError(response.message));
    toast.error(response.message);
    yield put(togglePageLoader(false));
   }
  } catch (error) {
    toast.error(error?.response?.data?.message || "An error occurred");
    yield put(togglePageLoader(false));
  }
}
function* fetchManualsByClientId({ payload: params }) {

  try {
    yield put(togglePageLoader(true));
    const clientId = params.clientId ||params;   
    const response = yield call(getManualbyClientId, { clientId });
    console.log(response,"reponse clem")
    if (response) {
      
      yield put(manualclinetListSuccess(response));
    } else {
      yield put(ManualListError(response.message));
      toast.error(response.message);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "An error occurred");
  } finally {
    yield put(togglePageLoader(false));
  }
}
function* getAllCategoryList({ payload: params }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getallCategory, params);
    if (response) {
    yield put(allCategoryListSuccess(response));
    yield put(togglePageLoader(false));
     } else {
    yield put(categoryListError(response));
    toast.error(response.message);
    yield put(togglePageLoader(false));
  }
  } 

  catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* getAllChangetypeList({ payload: params }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getallChangetype, params);
     if (response) {
    yield put(allChangetypeListSuccess(response));
    yield put(togglePageLoader(false));
     } else {
    yield put(ChangetypeListError(response));
    toast.error(response.message);
    yield put(togglePageLoader(false));
  }
  } 

  catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}
function* createNewManual({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(postAddManual, params);
    if (response && response.message!=="Manual name already exists.") {
    yield put(onAddnewManualSuccess(response));
    yield put(togglePageLoader(false));
    toast.success(response.message);
    callback("ADD SUCCESS");
    } else {
    yield put(onAddnewManualError(response));
    toast.error(response.message);
    yield put(togglePageLoader(false));
    callback("ADD FAILURE");
    }
    
  } catch (error) {
    yield put(onAddnewManualError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* updatenewManual({ payload: data, callback }) {
  try {

    yield put(togglePageLoader(true));
    const response = yield call(patchUpdateManual, data);
    if (response  && response.message!=="Manual name already exists.") {
    yield put(onupdateManualSuccess(response));
    yield put(togglePageLoader(false));
    toast.success(response.message);
    callback("SUCCESS");
     } else {
    //notificationColor = "red";
    yield put(onupdateManualError(response));
    toast.error(response.message);
    yield put(togglePageLoader(false));
    callback("FAILURE");
     }
   
  } catch (error) {
    yield put(onupdateManualError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* deleteManual({ payload: Id,callback }) {
  let notificationColor;
  try {
    yield put(togglePageLoader(true));
    const response = yield call(deleteManualById, Id);
    if (response) {
      yield put(onDeletemanualSuccess(Id));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      notificationColor = "lime";
      callback("SUCCESS");
    } else {
      //notificationColor = "red";
      yield put(onDeletemanualError(response));
      toast.error(response.message);
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onDeletemanualError(error));
    toast.error(error?.response ? error.response.data.message : error.message);
  } finally {
    yield put(togglePageLoader(false));
  }
}
function* createNewDrawing({ payload: params, callback }) {
  try {
    let notificationColor;
    yield put(togglePageLoader(true));
    const reqFormData = new FormData();
    reqFormData.append("siteId", parseInt(params.sitename, 10));
    reqFormData.append("clientId", params.clientId ? parseInt(params.clientId, 10) : null);
    reqFormData.append("categoryId", parseInt(params.categoryname, 10));
    reqFormData.append("Title", params.title); 
    const fileList = Array.isArray(params.uploadFile) ? params.uploadFile : [];

    if (fileList.length > 0) {
      fileList.forEach((file, index) => {
        if (file instanceof File) {
          reqFormData.append("uploadFile", file);
        }
      });
    } else if (params.imageUrl) {
      reqFormData.append("imageUrl", params.imageUrl);
    }
    const response = yield call(postAddDrawing, reqFormData);
    if (response) {
      yield put(onAddnewDrawingSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      notificationColor = "lime";
      callback("ADD SUCCESS");
    } else {
      notificationColor = "lime";
      yield put(OnAddnewDrawingError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
      callback("ADD FAILURE");
    }
  } catch (error) {
    yield put(OnAddnewDrawingError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* updatenewDrawing({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true));
    const reqFormData = new FormData();
    reqFormData.append("id", data.id);
    reqFormData.append("siteId", data.siteId);
    reqFormData.append("clientId", data.clientId);
    reqFormData.append("categoryId", data.categoryId);
    reqFormData.append("Title", data.title);

    if (data.imageUrl) {
      reqFormData.append("imageUrl", data.imageUrl);
    }
    else {    
      reqFormData.append("uploadFile", data.uploadFile);
    }
    const response = yield call(patchUpdateDrawing, reqFormData);
    if (response) {
    yield put(onupdateDrawingSuccess(response));
    yield put(togglePageLoader(false));
    toast.success(response.message);
    callback("SUCCESS");
    } else {
   // notificationColor = "red";
    yield put(onupdateDrawingError(response));
    toast.error(response.message);
    yield put(togglePageLoader(false));
    callback("FAILURE");
    }
  
  } catch (error) {
    yield put(onupdateDrawingError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* deleteDrawing({ payload: Id, callback }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(deleteDrawingById, Id);
    if (response.statusCode === 200 || response === true) {
      yield put(onDeletedrawingSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.statusMessage);
      callback("SUCCESS");
    } else {
      yield put(onDeletedrawingError(response));
      toast.error(response.statusMessage);
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onDeletedrawingError(error));
    toast.error(error?.response ? error.response.data.message : error.message);
  } finally {
    yield put(togglePageLoader(false));
  }
}
function* CategoryfetchDrawingBySiteId({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getDrawingbySiteId, params, exportname);
    if (exports !== "export") {
      if (response.statusCode === 200) {
      yield put(CategorydrawinglistbysiteSucess(response));
      yield put(togglePageLoader(false));
       } else {
      yield put(CategorydrawinglistbysiteError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
    }
    } 
    else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}
function* getManualUrlList() {
  yield takeEvery(MANUAL_URL, getManualsUrlList);
  yield takeEvery(MANUAL_BY_SITEID, fetchManualsBySiteId);
  yield takeEvery(MANUAL_BY_CLIENT, fetchManualsByClientId);
  yield takeEvery(ALL_CATEGORY_DATA_SUCCESS, getAllCategoryList);
  yield takeEvery(ADD_MANUAL, createNewManual);
  yield takeEvery(UPDATE_NEW_MANUAL, updatenewManual);
  yield takeEvery(DELETE_MANUAL_BYID, deleteManual);
  yield takeEvery(ADD_DRAWING, createNewDrawing);
  yield takeEvery(UPDATE_NEW_DRAWING, updatenewDrawing);
  yield takeEvery(DELETE_DRAWING_BYID, deleteDrawing);
  yield takeEvery(ALL_CHANGETYPE_DATA, getAllChangetypeList);
  yield takeEvery(CATEGORY_DRAWING_DATA, CategoryfetchDrawingBySiteId);
}

export default getManualUrlList;
